/* §181（旧 §180）：PDP 画像拡大の「生姜」＝枚数表示 n / N（マイクロラベルの声・aria-live）。
   追従は純正 zoom-dialog の zoom-media:selected（bubbles）。ただし**開いた瞬間**は
   スクロールが起きない限り純正イベントが飛ばない（画像 1 枚・先頭から開いた時）ため、
   dialog の open 属性を観測して初期値をサムネの選択状態（aria-selected）から拾う。
   画像が 1 枚だけの商品では出さない。Horizon コアは非編集（HANDOFF §3）。 */
(function () {
  'use strict';

  function mediaCount(zd) {
    return zd.querySelectorAll('.dialog-zoomed-gallery__dialog .product-media-container').length;
  }

  function ensureCounter(dlg) {
    var el = dlg.querySelector('.ig-zoom-count');
    if (!el) {
      el = document.createElement('span');
      el.className = 'ig-zoom-count';
      el.setAttribute('aria-live', 'polite');
      dlg.appendChild(el);
    }
    return el;
  }

  function setCount(zd, index) {
    var dlg = zd.querySelector('.dialog-zoomed-gallery__dialog');
    if (!dlg) return;
    var total = mediaCount(zd);
    var el = ensureCounter(dlg);
    if (total < 2) { el.textContent = ''; return; }
    el.textContent = (index + 1) + ' / ' + total;
  }

  function selectedIndex(zd) {
    var btns = zd.querySelectorAll('.dialog-thumbnails-list button');
    for (var i = 0; i < btns.length; i++) {
      if (btns[i].getAttribute('aria-selected') === 'true') return i;
    }
    return 0;
  }

  /* 追従①（PC）＝純正イベント。dialog 自身が縦スクローラーの時だけ飛ぶ */
  document.addEventListener('zoom-media:selected', function (e) {
    var zd = e.target && e.target.closest ? e.target.closest('zoom-dialog') : null;
    if (!zd || !e.detail || typeof e.detail.index !== 'number') return;
    setCount(zd, e.detail.index);
  });

  /* 追従②（SP）＝実スクローラーは ul.dialog-zoomed-gallery の**横**スワイプで、
     純正の追跡（dialog の縦 scroll 前提）はここでは一度も発火しない（実測 2026-08-14）。
     scroll は bubble しないので document capture で拾う。1 枚＝コンテナの幅。 */
  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (!(t instanceof Element) || !t.matches('ul.dialog-zoomed-gallery')) return;
    var zd = t.closest('zoom-dialog');
    if (!zd) return;
    var w = t.clientWidth || 1;
    setCount(zd, Math.max(0, Math.round(t.scrollLeft / w)));
  }, true);

  /* 初期値（開いた瞬間）＝open 属性の観測。サムネの選択が付くのを 1 拍待って拾う */
  function arm(zd) {
    var dlg = zd.querySelector('.dialog-zoomed-gallery__dialog');
    if (!dlg || dlg.dataset.igZc === '1') return;
    dlg.dataset.igZc = '1';
    new MutationObserver(function () {
      if (dlg.open) window.setTimeout(function () { setCount(zd, selectedIndex(zd)); }, 120);
    }).observe(dlg, { attributes: true, attributeFilter: ['open'] });

    /* §181-3b：スマホ幅の縦流しスクロールを成立させる盾。
       純正 DragZoomWrapper は ≤749px でのみ touchstart/move を passive:false で構え、
       **touchstart で無条件 preventDefault**＝画面全面が画像のため、指のスクロールが
       全部飲まれて「一切スクロールしない」symptom になる（user 実機報告 2026-08-14）。
       縦流し（§181-3＝iPad と同型）ではピンチ部品ごと使わないので、capture 段で
       伝播を止めて部品に届かせない（passive:true＝ネイティブスクロールは素通し）。 */
    ['touchstart', 'touchmove', 'touchend'].forEach(function (type) {
      dlg.addEventListener(type, function (e) {
        if (window.matchMedia('(max-width: 749px)').matches) e.stopPropagation();
      }, { capture: true, passive: true });
    });
  }

  function scan() {
    document.querySelectorAll('zoom-dialog').forEach(arm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan, { once: true });
  } else {
    scan();
  }
  /* morph・遅延描画にも追従 */
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
})();
